$(document).ready(function () {
    var gallery = true;
    $(".lightgallery").lightSlider({
        gallery: gallery,
        item: 1,
        slideMargin: 0,
        enableDrag: false,
        onBeforeStart: function (el) {
            if (el.context.children.length == 1) {
                gallery = false;
            }
        },
        onSliderLoad: function (el) {
            el.lightGallery({
                selector: '.lightgallery .lslide'
            });
        }
    });

    $(document).on('click', 'a[href="#immagini_row"]', function (e) {
        e.preventDefault();
        $(this).closest('.panel-asta').find('.lightgallery .lslide.active').trigger('click');
    });

    $('.slider').lightGallery({
        thumbnail: true,
        selector: '.gallery-item'
    });

    $(document).on('change', '.ajaxable', function () {
        var form = $(this).closest('form');
        var selected = $(this).attr('name');

        var regione = $('[name="regione"]', form);
        var provincia = $('[name="provincia"]', form);
        var comune = $('[name="comune"]', form);

        $.ajax({
            url: '/aste/ajax/data',
            method: 'POST',
            data: {
                regione: regione.val(),
                provincia: provincia.val(),
                comune: comune.val(),
                selected: selected,
            },
            success: function (response) {

                if (_.has(response, 'regioni')) {
                    provincia.empty();
                    comune.empty();
                    $.each(response.province, function (key, value) {
                        provincia.append($('<option>', { value: key })
                            .text(value));
                    });
                }

                if (_.has(response, 'province')) {
                    provincia.empty();
                    comune.empty();
                    $.each(response.province, function (key, value) {
                        provincia.append($('<option>', { value: key })
                            .text(value));
                    });
                }

                if (_.has(response, 'comuni')) {
                    comune.empty();
                    $.each(response.comuni, function (key, value) {
                        comune.append($('<option>', { value: key })
                            .text(value));
                    });
                }
            }
        });
    });

    $(document).on('change', '#calendario_t', function () {
        $('#data_da_t').val('');
        $('#data_a_t').val('');
        $('#mese_anno_vendita_t').focus();
    });

    $(document).on('change', '#periodo_t', function () {
        $('#mese_anno_vendita_t').val('');
        $('#data_da_t').focus();
    });

    $(document).on('focus', '#mese_anno_vendita_t', function () {
        $('#calendario_t').prop("checked", true);
        $('#data_da_t').val('');
        $('#data_a_t').val('');
    });

    $(document).on('focus', '#data_da_t, #data_a_t', function () {
        $('#periodo_t').prop("checked", true);
        $('#mese_anno_vendita_t').val('');
    });

    $(document).on('submit', '.form-ricerca form', function () {
        var form = $(this);

        var selected_count = $('select, input[type="text"]', form).not('[name="limit"], [name="orderby"]').filter(function () {
            return $(this).val() != '' && !_.isNull($(this).val()) && $(this).val() != 0
        }).length;

        if (selected_count > 0) {

            var date_input_counter = 0;
            var date_input_format_counter = 0;

            $('.date-input').each(function () {
                if ($(this).val() != '' && !_.isNull($(this).val())) {
                    if (!isValidDate($(this).val(), 'DD/MM/YYYY')) {
                        date_input_counter++;
                    }
                }
            });

            $('.date-input-format').filter(function () {
                if ($(this).val() != '' && !_.isNull($(this).val())) {
                    if (!isValidDate($(this).val(), 'MM/YYYY')) {
                        date_input_format_counter++;
                    }
                }
            });

            if (date_input_counter > 0 || date_input_format_counter > 0) {
                swal('Errore!', 'Inserire una data valida!', 'error');
                return false;
            }

            return true;
        } else {
            swal('Errore!', 'Specificare almeno un campo di ricerca!', 'error');
            return false;
        }
    });
});

function isValidDate(str, format) {
    var d = moment(str, format);
    return !(d == null || !d.isValid());
}